<template>
    <div id="productListContainer">
        <Button class="btn-close" close @click="$emit('modalClosed')" />
        <PochiRadioToggleButtons v-if="modalType === 'roasProduct'" class="switchProductType" v-model="productType"
            :values="[
                { label: '単品商品集計', value: 'single' },
                { label: '商品グループ集計', value: 'totalling' },
            ]" />
        <ProductList v-if="productType != 'totalling'" show-selected return-object :value="inputedProduct.id"
            :modalType="modalType" @input="product => inputedProduct = product" v-bind:listColumn=listColumnSuu
            @changeProductType="changeProductType">
            <template v-slot:header-action>
                <template
                    v-if="modalType === 'roasProduct' || modalType === 'mallAd' || modalType === 'mallPoint' || modalType === 'productMaster'">
                    <div class="allproductRoas" @click="inputedProductId = -1"><span>全商品</span></div>
                </template>
            </template>
        </ProductList>
        <TotallingTargetList v-if="productType == 'totalling'" return-object :value="inputedTotallingTarget.id"
            @input="totallingTarget => inputedTotallingTarget = totallingTarget" :productId=productId>
        </TotallingTargetList>
    </div>
</template>

<script>
import ProductList from '@/components/ProductList.vue';
import TotallingTargetList from '@/components/TotallingTargetList.vue';
import responsive from '@/helpers/responsive'

export default {
    name: 'ShowProduct',
    components: {
        ProductList,
        TotallingTargetList,
    },
    props: {
        value: {
            /*
            * modalType === 'roasProduct'
            *     Object: {
            *         type: 'nomal',
            *         product: { id: Number },
            *     }
            *     Object: {
            *         type: 'single',
            *         product: { id: Number },
            *     }
            *     Object: {
            *         type: 'totalling',
            *         totallingTarget: { id: Number },
            *     }
            * modalType !== 'roasProduct'
            *     Number: productId
            */
            type: [Object, Number],
            required: true,
        },
        selectedProductAndRateIndex: Number,
        modalType: String,
    },
    data() {
        return {
            productType: 'single',
            listColumnSuu: 3,
            productId: 0,
        }
    },
    watch: {
        productType: {
            handler: function () {
                if (this.productType == 'single') {
                    this.productId = 0;
                }
            }
        }
    },
    computed: {
        inputedValue: {
            get() {
                const value = {
                    type: 'single',
                    product: { id: null, name: null, },
                    totallingTarget: { id: null, name: null, },
                };

                if (this.modalType === 'roasProduct' || this.modalType === 'productMaster') {
                    return {
                        ...value,
                        ...this.value,
                    };
                } else {
                    value.product.id = this.value;
                    return value;
                }
            },
            set(newValue) {
                if (this.modalType === 'roasProduct' || this.modalType === 'productMaster') {
                    this.$emit('input', {
                        ...newValue,
                        type: this.productType,
                    });
                } else {
                    this.$emit('selectProduct', {
                        productId: newValue.product.id,
                        productName: newValue.product.name,
                        selectedProductAndRateIndex: this.selectedProductAndRateIndex,
                    })
                }
                this.$emit('modalClosed');
            },
        },
        inputedProductId: {
            get() {
                return this.inputedValue.product.id;
            },
            set(newValue) {
                const product = { ...this.inputedValue.product };
                product.id = newValue;
                if (product.id === -1) {
                    product.name = '全商品';
                }
                this.inputedValue = { ...this.inputedValue, product };
            },
        },
        inputedProduct: {
            get() {
                return this.inputedValue.product;
            },
            set(newValue) {
                this.inputedValue = { ...this.inputedValue, product: newValue };
            },
        },
        inputedTotallingTargetId: {
            get() {
                return this.inputedValue.totallingTarget.id;
            },
            set(newValue) {
                const totallingTarget = this.inputedValue.totallingTarget;
                totallingTarget.id = newValue;
                this.inputedValue = { ...this.inputedValue, totallingTarget };
            },
        },
        inputedTotallingTarget: {
            get() {
                return this.inputedValue.totallingTarget;
            },
            set(newValue) {
                this.inputedValue = { ...this.inputedValue, totallingTarget: newValue };
            },
        },
    },
    mounted() {
        this.productType = this.inputedValue.type;
        this.listColumnSuu = responsive.recycleScrollerListColumn();
        window.addEventListener('resize', this.resizeWindow);
    },
    methods: {
        resizeWindow() {
            this.listColumnSuu = responsive.recycleScrollerListColumn();
        },
        changeProductType(productId) {
            this.productId = productId;
            this.productType = 'totalling';
        },
    }
}
</script>

<style scoped lang="sass">
#productListContainer
    padding: 15px
    height: 100%
    width: 100%
    .btn-close
        position: absolute
        top: 15px
        right: 15px
    .switchProductType
        position: absolute
        top: 27px
        right: 33px
        align-items: center;
        padding: 0;
        height: 40px;
        white-space: nowrap;
        cursor: pointer;
        color: $grayColor
        font-size: 1.5rem;
        margin-right: 148px
        float: left
    .allproductRoas
        display: inline-flex;
        align-items: center;
        padding: 7px 24px;
        // width: 24%;
        height: 40px;
        background: #f5f5f5;
        white-space: nowrap;
        cursor: pointer;
        color: $grayColor
        font-size: 1.5rem;
        margin-right: 55px
        float: right
        text-align:center
        border: 1px solid $mainColor
        &:hover
            background: $mainColor
            color: $whiteColor
            transition: 0.2s ease-out
    
@include sp()
    #productListContainer
        .switchProductType
            position: relative
            top: 10px
            right: auto
            height: auto
            margin-right: 0
            margin-top: 11px
            float: none

</style>
